var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _path48, _g2, _path49, _path50, _path51, _g3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgLeaderboardShare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 186,
    fill: "none",
    viewBox: "0 0 240 186",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img_leaderboard_share_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__b)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M115.966 119.554c-1.665-5.635-8.894-4.92-6.68 1.221 1.362 3.779 2.069 7.265 3.34 10.661 2.22 5.929 4.452 10.38 4.655 10.945.32.888-.178 1.542-.888.213-.711-1.329-4.607-10.36-8.6-18.834-2.758-5.131-7.96-2.359-5.33 2.559 2.971 6.941 4.694 11.289 7.09 18.473.152.456-.321.685-.543.258-1.52-2.926-2.469-6.405-4.67-9.5-3.153-3.492-5.8-.238-3.545 3.222 3.545 9.436 4.439 19.67 17.047 32.753.499.978.996 2.172 1.486 3.531.979 2.716 1.928 6.085 2.809 9.684 1.763 7.199 3.254 15.314 4.171 20.961l.008.049 25.528-8.509-.049-.049a3 3 0 0 1-.329-.446 16 16 0 0 1-.483-.823 70 70 0 0 1-1.352-2.598c-1.049-2.102-2.364-4.869-3.764-7.868a1784 1784 0 0 1-4.278-9.255c-1.388-3.019-2.355-6.405-3.378-8.591 1.553-3.803 4.842-8.797 4.842-15.904 0-3.964.815-7.642 1.684-10.906a370 370 0 0 1 2.642-9.365c.991-3.334-3.26-3.903-5.309-1.343-1.158 1.982-4.996 8.165-6.062 14.562-1.635-6.823-7.427-17.182-9.633-25.101-1.627-5.841-7.867-4.67-6.333 1.847 1.902 8.086 4.089 9.815 5.315 18.507.079.554-.453.678-.804 0-3.438-6.637-6.339-12.75-8.587-20.354Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    stroke: "#6A6A6A",
    strokeWidth: 0.181,
    d: "M145.786 135.639c.399-1.366 1.198-3.481 1.577-4.544-3.223-1.749-4.972 3.507-1.577 4.544Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    d: "M145.852 135.658c.404-1.363 1.151-3.495 1.511-4.563-1.082-.759-3.487.611-1.913 2.232.731 1.124-.433 1.587.402 2.331"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M122.58 121.535c.453.662 1.226 1.366 2.45.896.784-.301 1.152-1.022 1.172-1.684.027-.881-.446-3.211-.932-3.448-1.509-1.037-4.163-.348-3.909 1.778.081.68.576 1.52 1.219 2.458"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M123.562 116.907a.8.8 0 0 1 .12.167c.379.715-.779 1.391-.335 2.228.331.625 1.214.175 1.52.753.213.401-.485 1.803-.207 2.328l.005.009q.222-.02.468-.117c.666-.262.963-.937.96-1.565-.003-.836-.481-3.065-.908-3.306a2.43 2.43 0 0 0-1.622-.498z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M110.684 121.155c.434.586 1.168 1.2 2.306.74a1.69 1.69 0 0 0 1.07-1.554c.011-.797-.467-2.888-.926-3.088-1.427-.894-3.899-.196-3.629 1.718.087.611.563 1.355 1.179 2.184"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M111.534 116.95q.074.076.115.147c.366.635-.707 1.279-.279 2.022.32.556 1.138.124 1.434.638.205.355-.426 1.642-.157 2.108l.004.008a1.6 1.6 0 0 0 .436-.119c.62-.256.886-.874.874-1.441-.016-.755-.498-2.755-.901-2.96a2.3 2.3 0 0 0-1.525-.404z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M103.023 126.134c.426.513 1.124 1.035 2.127.558.643-.306.908-.928.882-1.474-.033-.728-.582-2.612-1.008-2.772-1.34-.743-3.538.021-3.188 1.754.113.554.584 1.209 1.187 1.934"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M103.553 122.249a.7.7 0 0 1 .113.128c.365.562-.569 1.204-.141 1.861.32.49 1.037.055 1.333.508.205.315-.295 1.521-.026 1.933l.004.007q.186-.033.388-.131c.546-.265.754-.843.711-1.36-.056-.689-.603-2.49-.979-2.656a2.08 2.08 0 0 0-1.402-.291z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M100.913 138.653c.33.398.872.804 1.651.433.499-.238.705-.72.685-1.144-.026-.565-.452-2.028-.783-2.151-1.04-.577-2.746.016-2.475 1.361.088.43.454.938.922 1.501"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M101.326 135.636a.5.5 0 0 1 .087.099c.284.436-.441.935-.109 1.444.249.381.805.043 1.035.395.159.244-.229 1.181-.02 1.501l.003.005a1.1 1.1 0 0 0 .301-.102c.424-.205.585-.654.552-1.055-.044-.535-.468-1.933-.76-2.062a1.6 1.6 0 0 0-1.088-.226z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9AA50C",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M123.524 63.655c-27.29 5.771-43.187 24.823-80.92 46.471-.76.437-1.011 1.497-.502 2.186l10.036 13.569c.401.542 1.163.641 1.741.255 45.837-30.6 22.57-39.578 69.645-62.48Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M124.822 57.651c-27.504 7.595-39.94 24.757-65.166 42.063 86.91-49.018 122.778-26.924 158.291-65.13a4.44 4.44 0 0 0 1.154-3.32l-2.203-28.581c-.049-.64-.812-.847-1.195-.325-12.25 16.649-37.708 40.61-90.881 55.293Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__c)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M100.649 133.694c3.47.086 4.91-2.82 2.584-4.298-3.459-2.197-13.302.077-15.113.871l-.323 9.393c1.005-1.304 3.155-3.463 5.684-4.49 3.16-1.284 3.698-1.562 7.168-1.476Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M91.18 133.786c.06-1.214 1.768-2.397 4.73-3.412-1.15.755-3.786 5.215-.781 4.047-1.509.586-3.265 1.181-4.031 2.456-.01-.443.021-1.876.082-3.091"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__d)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M93.614 146.589c3.47.086 4.91-2.821 2.584-4.298-3.46-2.198-13.302.077-15.113.87l-.323 9.394c1.005-1.304 3.155-3.464 5.684-4.491 3.16-1.284 3.698-1.561 7.168-1.475Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M93.614 146.589c3.47.086 4.91-2.821 2.584-4.298-3.46-2.198-13.302.077-15.113.87l-.323 9.394c1.005-1.304 3.155-3.464 5.684-4.491 3.16-1.284 3.698-1.561 7.168-1.475"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M89.747 140.487c1.654.425 4.073.426 6.122 1.691-2.895.706-4.611.535-6.838 4.744z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__e)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M103.427 128.784c3.47.086 4.909-2.82 2.584-4.298-3.46-2.198-13.303.077-15.114.871l-.323 9.393c1.006-1.304 3.155-3.464 5.684-4.491 3.161-1.283 3.699-1.561 7.169-1.475Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M92.928 130.291c.622.717 2.435.252 3.264-.07-1.508.586-4.137 2.416-4.903 3.691-.01-.443.013-1.77.074-2.984.06-1.215.579-2.625 1.015-3.46-.199.829-.072 2.105.55 2.823"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__f)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M106.401 112.845c.36-3.715-6.54-1.355-10.966 1.275-16.64 9.888-24.195 21.892-28.72 40.404-1.846 6.441-5.927 42.203-6.463 44.703H83.93c.055-3.607-.685-36.947 0-41.644.856-5.872 4.315-5.546 6.706-16.328 2.054-9.26-2.321-12.568 7.604-20.126 3.207-2.442 7.791-4.462 8.162-8.284Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "m79.724 141.611 11.675-2.517-.153-3.352.005-3.542c-3.59 3.795-9.724 6.077-11.527 9.411"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M99.51 113.409c-.356.086-.685.154-.944.197a6 6 0 0 1-.331.048c-.087.01-.16.014-.207.01-.144-.013-.29-.103-.406-.193-.118-.093-.22-.2-.279-.272l-.071-.086.098-.047c1.376-.677 2.719-1.277 3.81-1.675l.031-.012.032.011c.126.044.271.108.402.187.131.078.256.176.335.291a.41.41 0 0 1 .055.406c-.059.141-.2.273-.431.398-.57.31-1.388.564-2.095.737Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M101.216 111.47c-1.087.397-2.427.996-3.802 1.672.11.134.388.408.619.429-.11-.446.624-.66 1.495-.914.428-.125.889-.26 1.3-.437.505-.217.64-.632.388-.75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__g)",
    d: "M93.283 142.382c-3.085 1.196-4.819 6.439-9.01 7.378-4.733 1.061-5.836.29-6.55-2.996-1.073-4.938 7.303-9.215 11.235-10.582 3.886-1.35 9.853-1.402 12.379-1.424l.089-.001c2.472-.022 2.33 3.256-.467 5.006-2.853 1.785-4.592 1.423-7.676 2.619"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M97.596 137.572a5.5 5.5 0 0 1-.894-.351 3 3 0 0 1-.298-.175.7.7 0 0 1-.174-.162 1.1 1.1 0 0 1-.113-.354 5 5 0 0 1-.069-.51 6 6 0 0 1-.022-.957l.008-.078.08-.003c1.743-.037 3.407-.117 4.585-.097l.069.001.018.067c.107.405.172.987.067 1.516-.105.53-.387 1.021-.986 1.205-.722.222-1.578.104-2.27-.102Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M100.755 134.889c-1.176-.02-2.976-.154-4.623.212-.041.394.024 1.487.177 1.728.327-1.095 1.07-.961 1.954-.801.435.078.903.163 1.373.11.576-.064 1.2-.773 1.119-1.249"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M84.277 149.758c4.19-.939 5.925-6.182 9.01-7.378s4.823-.834 7.675-2.619c2.798-1.75 2.939-5.028.467-5.006s-8.535.059-12.468 1.425-12.308 5.644-11.235 10.582"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M140.828 153.059c-2.284.898-5.119-1.539-3.398-3.282 2.559-2.593 11.539-2.583 13.266-2.256l2.15 8.074c-1.131-.93-3.991-2.886-6.386-3.272-2.994-.483-3.348-.162-5.632.736Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "m151.536 147.481-1.812 6.077c.025-2.69.126-4.187-1.847-6.282z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__h)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M136.431 145.258c-3.175.955-6.722-2.643-4.211-4.799 3.735-3.207 15.827-2.194 18.117-1.561l1.997 11.111c-1.42-1.378-5.054-4.33-8.237-5.117-3.978-.983-4.49-.589-7.666.366Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "m147.844 138.497 3.354 10.442c-1.621-3.248-4.709-8.378-7.757-10.646z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__i)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M136.463 135.784c-3.666-.262-5.922-5.387-2.471-6.63 5.133-1.851 17.26 3.964 19.383 5.522l-2.31 12.298c-.927-1.987-3.529-6.478-6.516-8.547-3.734-2.586-4.419-2.38-8.086-2.643Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "m150.763 139.007-2.813 4.004c-2.549-3.404-3.233-5.571-4.669-10.583z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m93.776 34.969 12.155.916-.249-4.092-6.497-.425-4.862-5.02-9-.292s-1.64 5.581-.211 14.52c1.785 11.173 8.85 21.04 16.524 26.031 4.846 3.152 12.775 4.558 16.267 4.71l-4.416-5.434c-4.218-.538-11.219-3.007-17.128-10.51-5.909-7.505-6.865-19.284-6.4-24.345z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m94.566 33.552 9.179.6-.112-4.422-6.498-.424-4.835-5.41-9.001-.269s-1.673 6.054-.293 15.727c1.725 12.092 8.737 22.74 16.386 28.104 4.83 3.387 12.754 4.867 16.247 5.013l-4.388-5.862c-4.216-.56-11.206-3.196-17.075-11.29-5.87-8.096-6.467-21.113-5.974-26.597l2.088.137z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M94.164 28.04c-.278-2.027.43-3.993 2.008-5.805 1.577-1.812 4.14-3.573 7.389-5.001s7.395-2.64 11.991-3.413c4.597-.773 9.8-1.148 15.167-.996 5.368.152 10.387.812 14.802 1.857s8.103 2.437 11.016 4.085 4.909 3.454 6.017 5.411 1.251 3.902.418 5.902c-.832 2-2.489 3.703-4.815 5.242s-5.131 2.784-8.419 3.813c-3.288 1.028-6.864 1.778-10.76 2.262a79 79 0 0 1-12.238.545c-4.257-.134-8.295-.574-11.971-1.285-3.676-.71-7.104-1.695-10.019-2.884s-5.451-2.654-7.27-4.269-3.051-3.5-3.324-5.465zm1.317.04c.244 1.887 1.36 3.668 3.148 5.26 1.788 1.59 4.122 2.95 6.976 4.12s6.062 2.102 9.647 2.786a73 73 0 0 0 11.551 1.238c4.111.122 8.096-.069 11.808-.53 3.711-.46 7.265-1.21 10.367-2.192s5.923-2.242 8.084-3.68 3.819-3.178 4.578-5.05c.759-1.874.594-3.842-.457-5.667-1.052-1.824-3.063-3.63-5.819-5.173s-6.392-2.919-10.579-3.901c-4.187-.983-9.03-1.629-14.168-1.773s-10.056.204-14.514.952c-4.458.747-8.308 1.855-11.502 3.254s-5.56 2.991-7.129 4.78-2.233 3.628-1.983 5.577"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M95.48 28.08c.245 1.887 1.36 3.668 3.149 5.26 1.788 1.59 4.122 2.95 6.976 4.12s6.062 2.102 9.647 2.786a73 73 0 0 0 11.551 1.238c4.111.122 8.096-.069 11.808-.53 3.711-.46 7.265-1.21 10.367-2.192s5.923-2.242 8.084-3.68 3.819-3.178 4.578-5.05c.759-1.874.594-3.842-.457-5.667-1.052-1.824-3.063-3.63-5.819-5.173s-6.392-2.919-10.579-3.901c-4.187-.983-9.03-1.629-14.168-1.773s-10.056.204-14.514.952c-4.458.747-8.308 1.855-11.502 3.254s-5.56 2.991-7.129 4.78-2.233 3.628-1.983 5.577m-1.325-.042c-.278-2.026.43-3.992 2.008-5.804 1.577-1.812 4.14-3.573 7.389-5.001s7.395-2.64 11.991-3.413c4.597-.773 9.8-1.148 15.167-.996 5.368.152 10.387.812 14.802 1.857s8.103 2.437 11.016 4.085 4.909 3.454 6.017 5.411 1.251 3.902.418 5.902c-.832 2-2.489 3.703-4.815 5.242s-5.131 2.784-8.419 3.813c-3.288 1.028-6.864 1.778-10.76 2.262a79 79 0 0 1-12.238.545c-4.257-.134-8.295-.574-11.971-1.285-3.676-.71-7.104-1.695-10.019-2.884s-5.451-2.654-7.27-4.269-3.051-3.5-3.324-5.465z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M98.923 60.773c-3.037-6.863-4.22-13.67-4.115-21.209.047-3.496.2-6.373.234-7.025l.007-.134v-.002c.182-3.052.3-4.4.537-6.004.291-1.8 1.394-3.506 3.169-5.065s4.352-3.033 7.452-4.224 6.898-2.18 11.05-2.809c4.151-.63 8.765-.92 13.517-.79 4.437.126 8.632.61 12.425 1.387s7.094 1.812 9.898 3.06 4.96 2.65 6.537 4.196 2.464 3.14 2.674 4.818v.001c.105.926.27 2.483.332 6.412.067 4.397-.048 7.728-.089 8.83-.262 7.115-1.352 12.12-4.375 18.495-3.604 7.62-8.311 14.392-13.184 21.255-1.718 2.42-3.434 4.837-5.09 7.284l-.024.035-24.683-.942-.022-.035c-1.643-2.688-3.337-5.352-5.032-8.017-4.057-6.38-8.159-12.606-11.218-19.518Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M94.168 28.04c-.278-2.027.43-3.993 2.008-5.805 1.576-1.812 4.14-3.573 7.389-5.001s7.394-2.64 11.991-3.413 9.8-1.148 15.167-.996c5.368.152 10.387.812 14.801 1.857 4.415 1.044 8.104 2.437 11.017 4.085s4.909 3.454 6.017 5.411 1.251 3.902.418 5.902c-.832 2-2.49 3.703-4.815 5.242s-5.131 2.784-8.419 3.813c-3.288 1.028-6.864 1.778-10.76 2.262a79 79 0 0 1-12.238.545c-4.257-.134-8.295-.574-11.971-1.285-3.676-.71-7.104-1.695-10.019-2.884s-5.451-2.654-7.27-4.269-3.051-3.5-3.324-5.465zm1.317.04c.244 1.887 1.359 3.668 3.147 5.26 1.789 1.59 4.123 2.95 6.977 4.12s6.062 2.102 9.647 2.786a73 73 0 0 0 11.551 1.238c4.111.122 8.096-.069 11.808-.53 3.711-.46 7.265-1.21 10.367-2.192s5.923-2.242 8.084-3.68 3.819-3.178 4.578-5.05c.759-1.874.594-3.842-.457-5.667-1.052-1.824-3.063-3.63-5.819-5.173s-6.392-2.919-10.579-3.901c-4.187-.983-9.03-1.629-14.168-1.773s-10.056.204-14.514.952c-4.458.747-8.308 1.855-11.502 3.254s-5.56 2.991-7.129 4.78-2.234 3.628-1.984 5.577"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M95.485 28.08c.244 1.887 1.359 3.668 3.147 5.26 1.789 1.59 4.123 2.95 6.977 4.12s6.062 2.102 9.647 2.786a73 73 0 0 0 11.551 1.238c4.111.122 8.096-.069 11.808-.53 3.711-.46 7.265-1.21 10.367-2.192s5.923-2.242 8.084-3.68 3.819-3.178 4.578-5.05c.759-1.874.594-3.842-.457-5.667-1.052-1.824-3.063-3.63-5.819-5.173s-6.392-2.919-10.579-3.901c-4.187-.983-9.03-1.629-14.168-1.773s-10.056.204-14.514.952c-4.458.747-8.308 1.855-11.502 3.254s-5.56 2.991-7.129 4.78-2.234 3.628-1.984 5.577m-1.324-.042c-.278-2.026.43-3.992 2.008-5.804 1.576-1.812 4.14-3.573 7.389-5.001s7.394-2.64 11.991-3.413 9.8-1.148 15.167-.996c5.368.152 10.387.812 14.801 1.857 4.415 1.044 8.104 2.437 11.017 4.085s4.909 3.454 6.017 5.411 1.251 3.902.418 5.902c-.832 2-2.49 3.703-4.815 5.242s-5.131 2.784-8.419 3.813c-3.288 1.028-6.864 1.778-10.76 2.262a79 79 0 0 1-12.238.545c-4.257-.134-8.295-.574-11.971-1.285-3.676-.71-7.104-1.695-10.019-2.884s-5.451-2.654-7.27-4.269-3.051-3.5-3.324-5.465z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m93.425 26.08.255-4.627c.113-2.02 1.12-3.96 2.895-5.741 1.775-1.782 4.451-3.492 7.737-4.889 3.287-1.396 7.369-2.556 11.857-3.303 4.489-.746 9.515-1.105 14.691-.96 4.846.14 9.41.692 13.523 1.595s7.656 2.1 10.615 3.542c2.959 1.443 5.199 3.051 6.759 4.818s2.344 3.566 2.382 5.446c.026 1.572.061 3.137.087 4.709-.032-1.825-.863-3.611-2.388-5.285s-3.872-3.3-6.795-4.68c-2.923-1.381-6.58-2.59-10.672-3.453-4.092-.864-8.716-1.425-13.593-1.567-5.207-.146-10.209.183-14.773.911-4.565.729-8.544 1.808-11.914 3.186s-5.942 2.954-7.77 4.726-2.785 3.607-2.896 5.565z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M93.427 26.081c.11-1.958 1.115-3.837 2.895-5.565s4.471-3.384 7.771-4.726 7.403-2.47 11.913-3.186 9.567-1.057 14.773-.91c4.878.14 9.464.686 13.594 1.566s7.696 2.047 10.672 3.452c2.976 1.406 5.225 2.968 6.794 4.681 2.338 2.552 3.139 5.765 1.531 8.818a9.6 9.6 0 0 1-.984 1.556l.003-.476c1.192-2.298 1.727-4.178.153-7.128-1.08-1.902-3.156-3.795-6.016-5.41-2.861-1.616-6.656-3.052-11.017-4.087-4.362-1.034-9.434-1.704-14.801-1.856s-10.509.21-15.168.996-8.664 1.949-11.991 3.413-5.772 3.136-7.39 5c-1.616 1.865-2.285 3.78-2.007 5.805a7.6 7.6 0 0 0 .95 2.75l-.018.49c-1.074-1.479-1.73-3.195-1.657-5.183Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M98.923 60.773c-3.037-6.863-4.22-13.67-4.115-21.209.047-3.496.2-6.373.234-7.025l.007-.134v-.002c.182-3.052.3-4.4.537-6.004.291-1.8 1.394-3.506 3.169-5.065s4.352-3.033 7.452-4.224 6.898-2.18 11.05-2.809c4.151-.63 8.765-.92 13.517-.79 4.437.126 8.632.61 12.425 1.387s7.094 1.812 9.898 3.06 4.96 2.65 6.537 4.196 2.464 3.14 2.674 4.818v.001c.105.926.27 2.483.332 6.412.067 4.397-.048 7.728-.089 8.83-.262 7.115-1.352 12.12-4.375 18.495-3.604 7.62-8.311 14.392-13.184 21.255-1.718 2.42-3.434 4.837-5.09 7.284l-.024.035-24.683-.942-.022-.035c-1.643-2.688-3.337-5.352-5.032-8.017-4.057-6.38-8.159-12.606-11.218-19.518Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M111.589 91.618c.088-.112.425-.506 1.254-.958 6.916-3.773 20.697-2.831 27.889.071.907.363 1.769.885 2.189 1.33.406.421 1.664 1.722-.355 3.438-.909-3.937-24.236-6.055-30.75-1.134-.861-.54-.946-1.824-.227-2.747Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M112.229 113.255c1.452-1.05 3.031-2.343 3.031-2.343 2.963-1.782 16.004-2.246 23.447.689 1.021.797 2.042 1.679 3.062 2.476-6.733-2.703-21.068-2.451-27.686-1.436-.903.181-1.531.38-1.854.614Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M109.84 118.234c.066-.143.15-.339.217-.482l.108-.241c.067-.144.151-.332.218-.483.066-.151.15-.332.216-.475l.109-.241c.066-.143.15-.332.217-.475.066-.143.15-.332.217-.475.033-.068.075-.166.108-.241.067-.143.15-.332.217-.475.066-.143.15-.332.217-.475.033-.068.075-.166.108-.241.067-.143.15-.332.217-.475.117-.264.624-.498 1.444-.706s1.992-.386 3.399-.518a70 70 0 0 1 4.939-.27 111 111 0 0 1 5.969.044c1.967.073 3.826.179 5.514.334 1.688.154 3.184.332 4.449.54 1.264.207 2.275.436 3.01.678s1.162.487 1.26.736c.064.148.141.343.197.49.028.07.07.171.098.249.064.148.141.343.197.49.056.148.14.343.196.49.028.07.071.172.098.249.064.148.141.343.197.49.056.148.14.343.204.491.028.078.07.171.098.249.064.148.141.342.204.49.064.148.141.343.204.498.028.078.071.171.098.249.064.148.141.35.204.498-.098-.249-.587-.504-1.398-.741s-1.983-.48-3.408-.701-3.158-.408-5.084-.571a126 126 0 0 0-6.317-.363 136 136 0 0 0-6.842-.076c-2.125.029-4.021.12-5.635.244s-2.909.299-3.851.509-1.481.444-1.606.708zM93.427 26.081c.11-1.958 1.115-3.837 2.895-5.565s4.471-3.384 7.771-4.726 7.403-2.47 11.913-3.186 9.567-1.057 14.773-.91c4.878.14 9.464.686 13.594 1.566s7.696 2.047 10.672 3.452c2.976 1.406 5.225 2.968 6.794 4.681 2.338 2.552 3.139 5.765 1.531 8.818a9.6 9.6 0 0 1-.984 1.556l.003-.476c1.192-2.298 1.727-4.178.153-7.128-1.08-1.902-3.156-3.795-6.016-5.41-2.861-1.616-6.656-3.052-11.017-4.087-4.362-1.034-9.434-1.704-14.801-1.856s-10.509.21-15.168.996-8.664 1.949-11.991 3.413-5.772 3.136-7.39 5c-1.616 1.865-2.285 3.78-2.007 5.805a7.6 7.6 0 0 0 .95 2.75l-.018.49c-1.074-1.479-1.73-3.195-1.657-5.183Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "img_leaderboard_share_svg__j",
    width: 69,
    height: 77,
    x: 94,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    d: "M98.923 60.773c-3.037-6.863-4.22-13.67-4.115-21.209.047-3.496.2-6.373.234-7.025l.007-.134v-.002c.182-3.052.3-4.4.537-6.004.291-1.8 1.394-3.506 3.169-5.065s4.352-3.033 7.452-4.224 6.898-2.18 11.05-2.809c4.151-.63 8.765-.92 13.517-.79 4.437.126 8.632.61 12.425 1.387s7.094 1.812 9.898 3.06 4.96 2.65 6.537 4.196 2.464 3.14 2.674 4.818v.001c.105.926.27 2.483.332 6.412.067 4.397-.048 7.728-.089 8.83-.262 7.115-1.352 12.12-4.375 18.495-3.604 7.62-8.311 14.392-13.184 21.255-1.718 2.42-3.434 4.837-5.09 7.284l-.024.035-24.683-.942-.022-.035c-1.643-2.688-3.337-5.352-5.032-8.017-4.057-6.38-8.159-12.606-11.218-19.518"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#img_leaderboard_share_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    d: "m158.18 75.276-53.04-3.405c39.74-7.828 51.113-26.438 35.605-58.488l30.907 4.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m140.883 95.76-24.6-.938c-4.147-6.784-8.609-13.4-12.597-20.278-.108-1.016.51-1.982 1.746-2.856 10.449-7.393 37.383-6.954 48.282 1.531 1.1.857 1.097 2.175.637 2.919-4.169 6.73-9.031 13.066-13.468 19.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m140.832 97.038-24.6-.938c-4.147-6.784-8.608-13.4-12.596-20.279-.108-1.016.51-1.982 1.745-2.856 10.449-7.392 37.383-6.953 48.282 1.532 1.101.857 1.097 2.174.637 2.918-4.169 6.731-9.031 13.067-13.468 19.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "m145.641 15.423 23.014 4.964-3.452 38.662-11.211 9.415c8.664-29.166 1.157-47.88-8.351-53.04"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m93.425 26.08.255-4.627c.113-2.02 1.12-3.96 2.895-5.741 1.775-1.782 4.451-3.492 7.737-4.889 3.287-1.396 7.369-2.556 11.857-3.303 4.489-.746 9.515-1.105 14.691-.96 4.846.14 9.41.692 13.523 1.595s7.656 2.1 10.615 3.542c2.959 1.443 5.199 3.051 6.759 4.818s2.344 3.566 2.382 5.446c.026 1.572.061 3.137.087 4.709-.032-1.825-.863-3.611-2.388-5.285s-3.872-3.3-6.795-4.68c-2.923-1.381-6.58-2.59-10.672-3.453-4.092-.864-8.716-1.425-13.593-1.567-5.207-.146-10.209.183-14.773.911-4.565.729-8.544 1.808-11.914 3.186s-5.942 2.954-7.77 4.726-2.785 3.607-2.896 5.565zM139.14 92.514c-1.063-2.104-15.785-4.1-23.746-1.007 0 0-2.013-2.366-2.411-3.014-.397-.648.206-1.221.971-1.592 6.341-3.07 19.692-3.294 27.506.908.583.42.789.857.581 1.294z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "img_leaderboard_share_svg__k",
    width: 31,
    height: 9,
    x: 112,
    y: 84,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.181,
    d: "M139.14 92.512c-1.063-2.103-15.785-4.1-23.746-1.007 0 0-2.013-2.366-2.411-3.014-.397-.648.206-1.221.971-1.592 6.341-3.07 19.692-3.294 27.506.908.583.42.789.857.581 1.294z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#img_leaderboard_share_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "m142.284 92.9-12.039-3.269c1.781-1.78 3.07-3.754.768-5.933l14.198 4.29z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M115.142 111.202c1.423-2.466 3.616-5.867 3.591-8.812 1.193-2.267 15.581-1.89 16.839.43-.11 2.971 1.937 6.49 3.3 9.028-.108-.203-.475-.416-1.066-.607-.591-.19-1.404-.381-2.402-.548a47 47 0 0 0-3.494-.436 83 83 0 0 0-4.298-.265 74 74 0 0 0-4.659-.027 55 55 0 0 0-3.879.225c-1.124.112-2.041.254-2.714.429-.674.174-1.095.366-1.218.583Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M142.949 95.144c-2.054 2.055-7.355 4.586-7.382 7.834-4.398-1.871-15.031-1.465-16.84-.519-.344-1.529-1.237-4.433-6.928-8.191.17-4.6 31.805-3.013 31.15.876Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "img_leaderboard_share_svg__l",
    width: 33,
    height: 13,
    x: 111,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.181,
    d: "M142.949 95.146c-2.054 2.055-7.355 4.586-7.382 7.834-4.398-1.871-15.031-1.465-16.84-.519-.344-1.529-1.237-4.433-6.928-8.191.17-4.6 31.805-3.013 31.15.876Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#img_leaderboard_share_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "m142.574 104.525-13.966-2.706c2.771-2.301 5.805-6.014 3.094-11.055l13.747 2.911z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M111.589 91.62c.088-.112.425-.506 1.254-.958 6.916-3.773 20.697-2.831 27.889.071.907.363 1.769.885 2.189 1.33.406.421 1.664 1.722-.355 3.438-.909-3.937-24.236-6.056-30.75-1.135-.861-.539-.946-1.823-.227-2.746Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m168.714 25.846-14.201.438-1.616-1.784 2.19-3.39 11.306-.207 15.73-6.877 2.642.83c.637 20.112-8.619 51.325-34.621 50.366l-6.154-1.434 7.644-6.148c17.514-5.906 24.636-21.335 24.359-37.209z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m168.012 24.057-15.102.422.511-4.857 11.956-.449 6.11-5.558 10.533.442s1.433 6.8-1.008 17.332c-4.426 19.098-13.693 33.346-37.198 32.478l1.45-6.585c4.971-.27 13.788-.812 21.336-9.24s9.362-22.704 9.258-28.78l-2.45-.02zM93.61 144.257l.45-26.492 42.026-7.295v29.138z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M157.877 148.865v-27.183l-21.791-11.054v28.979z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "m157.877 148.866-39.218 2.759-24.952-7.276 42.379-4.742z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__m)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M161.769 158.82c-3.476 9.996 8.961 31.705 12.062 36.53l-27.69 7.306-6.855-39.058c-1.349-5.963-.822-10.098 2.289-15.164 4.838-7.877 8.924-8.627 15.948-14.33 3.495-2.838 6.734-12.177 11.166-18.001 5.146-6.763 9.265-3.772 8.232-.491-1.953 6.205-10.806 30.712-15.152 43.208Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M149.434 154.981c8.229-4.912-.568-1.381-3.98-11.57-.402 2.224-4.88 9.331 3.98 11.57"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__n)",
    d: "M155.364 125.968c3.301-7.197 7.854-11.591 11.391-6.617-.381 2.432-8.668 15.065-10.733 29.752-2.849 7.825-19.249 10.515-16.023 1.691 4.54-12.416 9.336-11.682 15.365-24.826"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M156.144 148.894c2.106-15.18 9.521-25.741 10.517-29.598-4.442-5.636-8.799 1.102-12.858 9.753-3.131 6.672-7.438 9.571-9.998 13.872-1.628 2.736-3.188 5.04-4.489 10.365"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    stroke: "#6A6A6A",
    strokeWidth: 0.181,
    d: "M163.347 126.344c.815-1.727 2.236-4.405 2.931-5.75-2.203-2.15-5.528 4.5-2.931 5.75Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    d: "M163.397 126.366c.82-1.724 2.2-4.421 2.88-5.773-.68-.938-3.242.827-2.43 2.843.25 1.404-.92 2.006-.45 2.93"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    stroke: "#6A6A6A",
    strokeWidth: 0.181,
    d: "M174.726 121.286c.641-1.799 1.746-4.621 2.287-6.034-1.464-1.575-4.064 5.391-2.287 6.034Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    d: "M174.758 121.298c.644-1.797 1.721-4.629 2.252-6.046-.441-.745-2.311 1.451-1.82 3.186.121 1.274-.726 2.084-.432 2.86"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#A27A7D",
    d: "M139.105 161.674c.297 4.609 2.151 12.047 2.151 12.047 2.064-1.826 9.994-12.047 9.994-12.047s-9.305 5.93-12.145 0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__o)",
    stroke: "#252525",
    strokeWidth: 0.181,
    d: "M124.111 110.814c2.018-6.831 10.782-5.965 8.098 1.48-1.651 4.58-2.508 8.807-4.049 12.923-2.691 7.188-5.397 12.584-5.643 13.268-.388 1.077.215 1.87 1.077.259.861-1.611 5.584-12.559 10.425-22.832 3.343-6.22 9.649-2.859 6.461 3.102-3.601 8.414-5.69 13.686-8.595 22.394-.185.554.389.831.658.313 1.843-3.547 2.993-7.764 5.662-11.516 3.822-4.233 7.031-.288 4.297 3.906-4.297 11.439-5.382 23.846-20.665 39.705-.606 1.186-1.208 2.634-1.802 4.28-1.187 3.294-2.337 7.378-3.406 11.741-2.136 8.726-3.944 18.564-5.056 25.41l-.01.059-30.946-10.315.06-.059q.146-.148.398-.541c.166-.26.362-.595.586-.997a85 85 0 0 0 1.639-3.151c1.272-2.548 2.865-5.902 4.563-9.537s3.498-7.55 5.186-11.22c1.682-3.66 2.855-7.765 4.094-10.415-1.882-4.609-5.87-10.663-5.87-19.28 0-4.805-.987-9.264-2.041-13.221a444 444 0 0 0-3.203-11.353c-1.201-4.041 3.953-4.731 6.436-1.628 1.404 2.404 6.057 9.899 7.35 17.653 1.981-8.271 9.003-20.828 11.677-30.428 1.972-7.081 9.537-5.662 7.678 2.239-2.307 9.802-4.957 11.898-6.444 22.436-.095.671.55.821.975 0 4.168-8.047 7.685-15.457 10.41-24.675Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    stroke: "#6A6A6A",
    strokeWidth: 0.181,
    d: "M87.963 130.312c-.483-1.655-1.453-4.22-1.912-5.508 3.907-2.12 6.028 4.252 1.912 5.508Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9EF",
    d: "M87.887 130.335c-.49-1.653-1.396-4.237-1.833-5.532 1.312-.92 4.227.741 2.32 2.706-.886 1.363.525 1.924-.487 2.826"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M116.093 113.211c-.549.804-1.486 1.657-2.97 1.087-.95-.365-1.396-1.239-1.42-2.041-.033-1.069.54-3.893 1.129-4.18 1.829-1.258 5.047-.422 4.739 2.155-.099.824-.698 1.842-1.478 2.979"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M114.895 107.602q-.093.105-.146.203c-.459.867.945 1.686.407 2.7-.402.759-1.472.214-1.843.914-.258.486.588 2.186.251 2.822l-.006.011a2 2 0 0 1-.567-.142c-.808-.317-1.167-1.136-1.164-1.897.004-1.014.583-3.716 1.101-4.008a2.95 2.95 0 0 1 1.967-.603"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M130.517 112.754c-.527.71-1.417 1.454-2.796.897a2.05 2.05 0 0 1-1.297-1.885c-.014-.965.566-3.5 1.122-3.743 1.73-1.083 4.727-.237 4.399 2.082-.105.741-.682 1.644-1.428 2.649"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M129.484 107.652a1 1 0 0 0-.14.178c-.442.771.857 1.551.339 2.452-.388.673-1.38.15-1.739.773-.248.431.517 1.991.191 2.556l-.005.009a2 2 0 0 1-.528-.144c-.751-.31-1.075-1.059-1.059-1.747.019-.916.603-3.34 1.091-3.589a2.8 2.8 0 0 1 1.849-.489z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M139.804 118.792c-.516.621-1.362 1.255-2.579.675a1.86 1.86 0 0 1-1.069-1.786c.041-.883.706-3.167 1.222-3.36 1.625-.901 4.29.025 3.865 2.126-.136.671-.708 1.466-1.439 2.345"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M139.154 114.081a1 1 0 0 0-.136.155c-.444.681.689 1.46.17 2.255-.388.595-1.257.067-1.616.617-.248.381.358 1.844.032 2.343l-.006.009a1.8 1.8 0 0 1-.47-.159c-.662-.321-.913-1.022-.861-1.649.068-.835.73-3.018 1.186-3.22a2.52 2.52 0 0 1 1.7-.352z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFE7",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.181,
    d: "M142.36 133.966c-.4.482-1.057.974-2.002.524a1.445 1.445 0 0 1-.83-1.386c.032-.685.548-2.458.949-2.608 1.261-.699 3.33.019 3 1.65-.106.521-.55 1.138-1.117 1.82"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1D0",
    d: "M141.853 130.309a.7.7 0 0 0-.106.121c-.344.528.536 1.133.133 1.751-.301.461-.976.051-1.254.478-.193.296.277 1.432.024 1.819l-.004.007a1.4 1.4 0 0 1-.365-.124c-.514-.249-.709-.793-.669-1.279.053-.649.567-2.343.921-2.5a1.96 1.96 0 0 1 1.32-.273"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__p)",
    d: "M-2 0h68.066v186H-2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#img_leaderboard_share_svg__q)",
    d: "M-2 186h37.059v241.887H-2z",
    transform: "rotate(-90 -2 186)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.181,
    d: "m173.691 85.077-2.867.27a7.21 7.21 0 0 0-6.464 6.18l-.399 2.852c-.058.427-.682.413-.722-.017l-.27-2.866a7.21 7.21 0 0 0-6.18-6.465l-2.852-.399c-.427-.058-.414-.682.016-.722l2.867-.27a7.21 7.21 0 0 0 6.465-6.18l.399-2.852c.058-.427.682-.414.722.016l.27 2.867a7.21 7.21 0 0 0 6.18 6.465l2.852.399c.427.058.413.682-.017.722ZM180.166 95.62l-1.893.179a4.76 4.76 0 0 0-4.267 4.08l-.263 1.882c-.039.282-.451.273-.477-.011l-.178-1.892a4.76 4.76 0 0 0-4.08-4.268l-1.882-.263c-.283-.038-.273-.45.01-.476l1.893-.178a4.76 4.76 0 0 0 4.267-4.08l.263-1.883c.039-.282.451-.273.477.011l.178 1.893a4.76 4.76 0 0 0 4.08 4.267l1.882.263c.283.039.273.45-.01.477Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "M69.837 99.875 66.498 87.14l1.326-1.355 3.34 12.736z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m69.838 99.872-1.667-.707-3.338-12.733 1.666.705z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.106,
    d: "m66.076 87.16-1.682-.667 1.295-1.385 1.682.667z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "M67.6 91.267 56.92 48.439 62.17 43 72.852 85.83z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m67.601 91.266-6.727-2.856L50.19 45.583l6.73 2.855z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m56.92 48.437-6.73-2.855 5.254-5.437L62.172 43z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m56.528 45.737-4.925-18.195 1.315-1.364 4.926 18.194z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m56.524 45.738-1.671-.692-4.926-18.194 1.672.691z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.106,
    d: "m51.6 27.543-1.672-.692 1.315-1.364 1.672.691z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m208.188 62.395-3.808 9.448-2.001.358 3.808-9.449z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m208.188 62.394 1.016 1.654-3.808 9.448-1.016-1.654z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#79E90A",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m204.379 71.843 1.017 1.654-2.001.358-1.017-1.654z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#010E1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m205.703 67.336-10.449 25.069-8.055 1.166 10.502-24.933z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#79E90A",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m205.705 67.336 3.95 6.772-10.552 24.926-3.971-6.728z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7FFCE",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m195.19 92.258 3.949 6.772-8.004 1.302-3.947-6.772z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEFF9D",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m193.801 95.232-3.785 9.966-2.001.357 3.785-9.965zM193.801 95.232l1.017 1.653-3.783 9.966-1.018-1.654z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7FFCE",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.113,
    d: "m190.014 105.197 1.018 1.653-2.001.358-1.018-1.653z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-22.5846 151.652 52.5683 156.529 128.456 141.795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.7333 -6.58122 -3.77479 -13.9789 88.558 136.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.7333 -6.58122 -3.77479 -13.9789 81.523 149.185)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.7333 -6.58122 -3.77479 -13.9789 91.335 131.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19.215 74.4204 -176.393 143.846 80.171 137.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.7475 -4.3777 7.6033 41.2495 79.037 141.964)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#FFF9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.9499 -4.92125 1.93171 -17.1809 150.896 146.108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.3711 -13.8379 8.79272 -17.4814 151.113 142.366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-65.5805 41.8823 -73.6642 -87.1124 166.903 152.419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.15614 -34.3139 23.8703 -22.1661 151.535 149.517)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "img_leaderboard_share_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.3787 183.843 -63.7271 189.755 108.97 137.776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#FFB9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_leaderboard_share_svg__p",
    x1: 8.635,
    x2: 66.129,
    y1: 88.105,
    y2: 89.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_leaderboard_share_svg__q",
    x1: -2,
    x2: 35.059,
    y1: 306.944,
    y2: 306.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "img_leaderboard_share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2 0h241.887v186H-2z"
  })))));
};
export default SvgImgLeaderboardShare;